import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function LogoIcon({ className = "h-8 w-8" }) {
  return (
    <div className={`relative flex items-center justify-center ${className}`}>
      <img
        src="/logo-icon.png"
        alt="CVolve Pro"
        className="h-full w-full object-contain dark:hidden"
      />
      <img
        src="/logo-icon-dark.png"
        alt="CVolve Pro"
        className="h-full w-full object-contain hidden dark:block"
      />
    </div>
  );
}

export function Logo({ className = "", showIconOnly = false }) {
  const { user } = useAuth() || {};
  const targetPath = user ? (user.role === "recruiter" ? "/recruiter" : "/app") : "/";

  return (
    <Link
      to={targetPath}
      className={`group inline-flex items-center gap-2.5 transition-opacity hover:opacity-90 ${className}`}
      data-testid="cvolve-logo"
    >
      <LogoIcon className="h-8 w-8 shrink-0 transition-transform group-hover:scale-105" />
      {!showIconOnly && (
        <span className="flex items-baseline font-heading text-xl font-black tracking-tight leading-none text-foreground">
          CVolve
          <span className="ml-1 text-orange-500 font-extrabold">Pro</span>
        </span>
      )}
    </Link>
  );
}

